<div class="container">
  <div id="forum-profile-popup">
    <span ngbDropdownToggle class="icon-times">
      <i class="fa-solid fa-times"></i>
    </span>
    <div class="card shadow-lg h-100">
      <div class="card-body">
        <div class="text-center">
          <img loading="lazy" src="{{
              !user?.image
                ? '../../../assets/images/new/badge.png'
                : imgUrl + user?.image
            }}" class="shadow-sm rounded-circle border char-image" height="90px" width="90px" />
          <p class="text-center text-name" [routerLink]="['/community/profile', user?.referralCode]">
            {{ user?.userName }}
          </p>
          <p class="mb-1 text-center" style="font-size: 14px;">
            Level {{ user?.level }}
          </p>
        </div>
        <div class="text-left my-1">
          <p style="line-height: 13px; font-size: 13px">
            {{ user?.shortDescription || "" }}
          </p>
          <div class="d-flex flex-wrap mt-3" style="gap: 2px">
            <span class="badge-purple-region" *ngIf="user?.region">
              {{ user.region.split('|')[1] }}
            </span>
            <span class="badge-purple" *ngFor="let item of user?.certified">
              {{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>